<template>
  <hooper
    v-if="items.length > 0"
    :infiniteScroll="true"
    :autoPlay="true"
    :playSpeed="6500"
    :wheelControl="false"
    :style="'background-image: url(' + baseUrl + eyecatch + ')'"
    @beforeSlide="beforeSlide"
    @slide="sliding"
    @afterSlide="afterSlide"
    class="spot-slider"
    ref="hero"
  >
    <slide v-for="item in items" :key="item.id" :style="'background-image: url(' + baseUrl + item.image.url + ')'">
      <div v-if="item.caption" class="clickable" @click="toggleCaptionVisibility">
        <!-- <img :src="item.image" :alt="item.title" class="card-img-top" /> -->
        <span v-if="showCaption" class="caption spaced-bottom">{{item.caption}}</span>
      </div>
    </slide>
    <hooper-navigation slot="hooper-addons">
      <span class="icon-keyboard_arrow_left" slot="hooper-prev"></span>
      <span class="icon-keyboard_arrow_right" slot="hooper-next"></span>
    </hooper-navigation>
  </hooper>
  <div v-else ref="hero" class="card-image hero-image">
    <figure class="image is-6by4">
      <div class="clickable" @click="toggleCaptionVisibility">
        <img :src="baseUrl + eyecatch" :alt="caption">
        <span v-if="showCaption" class="caption">{{caption}}</span>
      </div>
    </figure>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    eyecatch: {
      type: String,
      default: null
    },
    caption: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      // window_width: 0,
      showCaption: true,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: false })
    this.handleResize()
  },

  methods: {
    handleResize: function(){
      // this.window_width = document.documentElement.clientWidth * 0.85
      // if(this.items.length > 0){
      //   this.$refs['hero'].$el.style.height = (this.window_width / 6) * 4 + "px"
      // } else {
      //   this.$refs['hero'].style.height = (this.window_width / 6) * 4 + "px"
      // }
    },
    beforeSlide: function(payload){ // eslint-disable-line no-unused-vars
      // console.log('beforeSlide')
    },
    sliding: function(payload){ // eslint-disable-line no-unused-vars
      // console.log('sliding')
      this.showCaption = true
    },
    afterSlide: function(payload){ // eslint-disable-line no-unused-vars
      // console.log('afterSlide')
    },
    toggleCaptionVisibility: function(){
      this.showCaption = !this.showCaption
    }
  },

  components: {
    Hooper,
    Slide,
    HooperNavigation,
  }
}
</script>
<style lang="sass">
.hooper
  overflow: hidden
  &.spot-slider
    max-height: 512px
    margin-bottom: 0
    background-size: cover
    background-position: center center
    &:before
      content: ''
      position: absolute
      top: -25px
      bottom: -25px
      left: -25px
      right: -25px
      background: inherit
      filter: blur(15px)
    .hooper-list
      .hooper-slide
        // background-color: #000
        background-size: contain
        background-repeat: no-repeat
        background-position: center center
        &.is-current
          transform: scale(1)
        .card-img-top
          object-fit: cover
      .hooper-navigation
        .hooper-next, .hooper-prev
          background-color: rgba($black, .65)
          padding: 12px 3px
          margin-top: -10px
          opacity: .7
          transition: opacity .2s linear
          &:hover
            opacity: 1
          [class^="icon-"], [class*=" icon-"]
            color: $white
            font-size: 22px
          &.is-disabled
            opacity: .2
</style>
